import styled from 'styled-components';
import { ReactNode } from 'react';
import LS from "../styles/layoutStyled";
import CS from "../styles/componentStyled";
import { alarmModal1State, alarmModal1Text } from '../atom/ModalAtom';
import { useRecoilState } from 'recoil';
import { useEffect, useState } from "react";

const AlarmModal1 = () => {
    const [alarmText, setAlarmText] = useRecoilState(alarmModal1Text);
    const [modalState, setModalState] = useRecoilState(alarmModal1State);

    useEffect(() => {
        if (alarmText === null) {
            setModalState(false);
        }
        else {
            setModalState(true);
        }
    }, [alarmText, setAlarmText, setModalState]);

    const closeModal = () => {
        setModalState(false);
        setAlarmText(null);
    };

    return (
        <>
            {modalState &&
                <CS.ModalBg>
                    <CS.ModalType1>
                        <p>{alarmText}</p>
                        <div className="btn-box">
                            <CS.Btn2Type1 type='button' onClick={closeModal}>확인</CS.Btn2Type1>
                        </div>
                    </CS.ModalType1>
                </CS.ModalBg>
            }
        </>
    );
}

export default AlarmModal1;